export const deBackendMessages = {
  errors: {
    accountLocked: `Ihr Konto wurde wegen mehrerer fehlgeschlagener Anmeldeversuche vorübergehend gesperrt. Bitte versuchen Sie es in {{remaining_time}} Minuten erneut.`,
    accountLockedAttemptsRemaining: `Die E-Mail-Adresse oder das Passwort ist falsch. {{attempts_left_until_lock}} verbleibend, bevor das Konto gesperrt wird.`,
    accountLockedOneMoreAttempt: `Die E-Mail-Adresse oder das Passwort ist falsch. Ein weiterer Fehlversuch führt zu einer 15-minütigen Kontosperre.`,
    answerNotFound: `Keine Antwort für folgende Frage gefunden: {{question_key}}.`,
    answerQuestionKeyInvalid: `Ungültiger question_key. Format muss „question_1“ bis „question_8“ sein.`,
    appleIapInvalidJson: `Ungültige JSON-Nutzlast`,
    appleIapMissingSignedPayload: `signedPayload fehlt`,
    appleIapWebhookProcessingFailed: `Webhook-Verarbeitung fehlgeschlagen`,
    chatArchivalTaskFailed: `Archivierungsauftrag konnte nicht eingereiht werden: {{error}}`,
    chatCeleryTestFailed: `Celery-Testaufgaben konnten nicht eingereiht werden: {{error}}`,
    chatQueryTooLong: `Die Anfrage ist zu lang, um verarbeitet zu werden.`,
    chatRulesRefreshFailed: `Chat-Regeln konnten nicht aktualisiert werden: {{error}}`,
    chatSessionAlreadyClosed: `Sitzung {{session_id}} ist bereits geschlossen`,
    chatSessionCloseAllFailed: `Sitzungen konnten nicht geschlossen werden: {{error}}`,
    chatSessionCloseFailed: `Sitzung konnte nicht geschlossen werden: {{error}}`,
    chatSessionGetActiveFailed: `Aktive Sitzungen konnten nicht abgerufen werden: {{error}}`,
    chatSessionNotFound: `Chatsitzung nicht gefunden`,
    chatStreamError: `Im Chat-Stream ist ein Fehler aufgetreten. Bitte erneut versuchen.`,
    decryptionFailed: `Gespeicherte Daten können nicht entschlüsselt werden. Bitte Support kontaktieren.`,
    encryptionServiceNotConfigured: `Verschlüsselungsdienst ist nicht korrekt konfiguriert. Bitte Support kontaktieren.`,
    expiredProviderToken: `Ihre Google- oder Apple-Anmeldung ist abgelaufen. Bitte erneut versuchen.`,
    fileDocxExceedsSizeLimit: `DOCX-Datei überschreitet das Größenlimit.`,
    fileImageExceedsSizeLimit: `Bild überschreitet das Größenlimit.`,
    fileImageTypeNotAllowed: `Bildtyp {{subtype}} ist nicht erlaubt.`,
    fileInsufficientPermissions: `Unzureichende Berechtigungen.`,
    fileNotFound: `Datei nicht gefunden.`,
    filePdfExceedsSizeLimit: `PDF-Datei überschreitet das Größenlimit.`,
    fileReadFailed: `Datei konnte nicht gelesen werden: {{error}}`,
    fileSizeExceedsLimit: `Dateigröße überschreitet das maximale Limit von {{max_files}} MB.`,
    fileTooManyFiles: `Zu viele Dateien. Maximal {{max_size}} Dateien pro Upload erlaubt.`,
    fileTooManyFilesAttached: `Zu viele Anhänge. Maximal {{max_files}} Dateien pro Nachricht erlaubt.`,
    fileTypeNotAllowed: `Dateityp {{file_type}} ist nicht erlaubt.`,
    fileUploadAzureFailed: `Datei konnte nicht nach Azure hochgeladen werden`,
    fileUploadFailed: `Upload fehlgeschlagen: {{error}}`,
    googlePlayInvalidBase64Json: `Ungültiges Base64/JSON: {{error}}`,
    googlePlayInvalidEnvelope: `Ungültiger Umschlag: {{error}}`,
    googlePlayMissingMessageIdOrData: `messageId oder Daten fehlen`,
    googlePlayMissingRequiredFields: `Erforderliche RTDN-Felder fehlen`,
    googlePlayPackageNameRequired: `Paketname ist erforderlich`,
    googlePlayPackageNotAllowed: `Paket {{package_name}} ist nicht zulässig`,
    googlePlayProcessingFailed: `Verarbeitung fehlgeschlagen: {{error}}`,
    googlePlayProductIdRequired: `Produkt-ID wird in den Kaufdetails benötigt`,
    googlePlayPurchaseDetailsRequired: `Kaufdetails sind erforderlich`,
    googlePlayPurchaseTokenRequired: `Kauf-Token ist erforderlich`,
    googlePlayPurchaseVerificationFailed: `Kaufverifizierung fehlgeschlagen: {{message}}`,
    googlePlayPurchaseVerificationFailedUnexpected: `Kaufbestätigung fehlgeschlagen aufgrund eines unerwarteten Fehlers.`,
    googlePlayServiceConfigurationError: `Konfigurationsfehler des Google-Play-Dienstes: {{error}}`,
    incorrectEmailOrPassword: `E-Mail oder Passwort falsch.`,
    incorrectPassword: `Falsches Passwort.`,
    internalServerError: `Interner Serverfehler.`,
    invalidProviderToken: `Anmeldung mit Google oder Apple konnte nicht bestätigt werden. Bitte erneut versuchen.`,
    invalidRefreshToken: `Ungültiger Aktualisierungstoken.`,
    invalidToken: `Ungültiger Token.`,
    invalidTokenType: `Ungültiger Tokentyp.`,
    notAuthenticated: `Nicht authentifiziert.`,
    couldNotValidateCredentials: `Anmeldedaten konnten nicht validiert werden.`,
    accountInactive: `Konto ist inaktiv oder zur Löschung vorgesehen.`,
    providerAuthFailed: `Die Anmeldung über Ihren Anbieter ist fehlgeschlagen. Bitte versuchen Sie es erneut oder verwenden Sie E-Mail und Passwort.`,
    unsupportedProvider: `Dieser Anmeldeanbieter wird nicht unterstützt.`,
    linkingRequired: `Diese Social-Identität muss mit einem bestehenden HARVN-Konto verknüpft werden, bevor Sie fortfahren können.`,
    accountLinkingFailed: `Diese Social-Identität konnte nicht mit Ihrem HARVN-Konto verknüpft werden. Bitte prüfen Sie Ihre Angaben und versuchen Sie es erneut.`,
    providerUnavailable: `Social Login ist vorübergehend nicht verfügbar. Bitte verwenden Sie stattdessen E-Mail und Passwort.`,
    onboardingIncomplete: `Ihr Konto ist noch nicht vollständig eingerichtet. Bitte schließen Sie die erforderlichen Schritte ab, bevor Sie fortfahren.`,
    accountCompletionNotRequired: `Ihr Konto ist bereits vollständig. Sie können HARVN normal weiter verwenden.`,
    tokenExpired: `Token ist abgelaufen.`,
    tokenRevoked: `Token wurde widerrufen.`,
    tokenLimitExceeded: `Token-Limit überschritten.`,
    debugTokenCheckFailed: `Fehler bei der Tokenprüfung: {{error}}`,
    passwordResetEmailFailed: `E-Mail zum Zurücksetzen des Passworts konnte nicht gesendet werden. Bitte später erneut versuchen.`,
    passwordSameAsCurrent: `Neues Passwort darf nicht mit dem aktuellen übereinstimmen`,
    passwordsDontMatch: `Passwörter stimmen nicht überein.`,
    questionnaireNotFound: `Fragebogen nicht gefunden.`,
    rateLimitExceeded: `Ratenlimit überschritten: {{limit_str}}`,
    assistantPromptNotFound: `Assistenten-Prompt nicht gefunden`,
    assistantPromptNotAuthorized: `Keine Berechtigung, auf diesen Prompt zuzugreifen`,
    assistantPromptNotAuthorizedToActivate: `Keine Berechtigung, diesen Prompt zu aktivieren`,
    assistantPromptNotAuthorizedToDelete: `Keine Berechtigung, diesen Prompt zu löschen`,
    assistantPromptNotAuthorizedToUpdate: `Keine Berechtigung, diesen Prompt zu aktualisieren`,
    validationDateInvalid: `Ungültiges Datumsformat.`,
    validationEmailInvalid: `Ungültiges E-Mail-Format.`,
    validationFieldRequired: `Feld ist erforderlich.`,
    validationGeneric: `Validierungsfehler.`,
    validationInvalidValue: `Ungültiger Wert.`,
    validationPasswordLength: `Passwort muss zwischen 8 und 40 Zeichen lang sein.`,
    validationStringTooLong: `Wert ist zu lang.`,
    validationStringTooShort: `Wert ist zu kurz.`,
    validationTypeError: `Ungültiger Typ.`,
    validationValueOutOfRange: `Wert liegt außerhalb des zulässigen Bereichs.`,
    rateLimitRetryAfter: `Ratenlimit erreicht. Bitte versuchen Sie es {{retry_after_formatted}} erneut.`,
    subscriptionAdminPrivilegesRequired: `Administratorrechte erforderlich.`,
    subscriptionAlreadyActive: `Der Benutzer hat bereits ein aktives Abonnement.`,
    subscriptionCancelled: `Ihr Abonnement wurde gekündigt. Bitte abonnieren Sie erneut.`,
    subscriptionCancelFailed: `Abonnement konnte nicht gekündigt werden.`,
    subscriptionCannotDowngrade: `Aktives Abonnement vorhanden – Downgrade nicht möglich.`,
    subscriptionCannotSwitchToSamePlan: `Ein Wechsel zum gleichen Abonnementplan ist nicht möglich.`,
    subscriptionDaysAdvanceLimit: `Es können nicht mehr als 365 Tage auf einmal vorgemerkt werden.`,
    subscriptionDayConsumptionFreemiumOnly: `Tagesverbrauch ist nur für Freemium-Testnutzer verfügbar.`,
    subscriptionDaysMustBePositive: `Verbrauchte Tage müssen positiv sein.`,
    subscriptionFreemiumActivationFailed: `Kostenlose Testphase konnte nicht aktiviert werden.`,
    subscriptionFreemiumExpired: `Kostenlose Testphase abgelaufen.`,
    subscriptionFreemiumTrialEnded: `Ihre kostenlose Testphase ist beendet. Bitte abonnieren Sie weiter.`,
    subscriptionFreemiumTokensExhausted: `Sie haben alle Tokens der Testphase verbraucht. Bitte abonnieren Sie, um fortzufahren.`,
    subscriptionExpired: `Ihr Abonnement ist abgelaufen. Bitte abonnieren Sie erneut.`,
    subscriptionInvalidPlanChoice: `Ungültige Planauswahl. Erlaubt sind Monats- oder Jahresplan.`,
    subscriptionInvalidStatus: `Ungültiger Abonnementstatus.`,
    subscriptionNoActiveSubscription: `Kein aktives Abonnement gefunden.`,
    subscriptionNotEnoughTokensRemaining: `Nicht genügend Tokens verfügbar.`,
    subscriptionPaymentConfigurationError: `Fehler in der Zahlungskonfiguration. Bitte kontaktieren Sie den Support.`,
    subscriptionPaymentProcessingError: `Fehler bei der Zahlungsverarbeitung: {{error}}.`,
    subscriptionPeriodEnded: `Ihre Abonnementperiode ist beendet. Bitte abonnieren Sie erneut.`,
    subscriptionStripeConfigurationError: `Stripe-Konfigurationsfehler: {{error}}.`,
    subscriptionStripeNotAvailable: `Stripe nicht verfügbar.`,
    subscriptionStripeNotConfigured: `Stripe nicht konfiguriert.`,
    subscriptionTrialNotInitialized: `Testphase nicht initialisiert.`,
    subscriptionUserAlreadyHasActiveSubscription: `Benutzer hat bereits ein aktives Abonnement.`,
    subscriptionNoStripeSubscriptionForBillingPortal: `Die Zahlungsmethode kann nur für aktive Abonnements aktualisiert werden. Kein aktives Abonnement gefunden.`,
    subscriptionNotFound: `Abonnement nicht gefunden.`,
    subscriptionTokensMustBePositive: `Verbrauchte Tokens müssen positiv sein.`,
    subscriptionWebhookInvalidPayload: `Ungültige Nutzlast`,
    subscriptionWebhookInvalidSignature: `Ungültige Signatur`,
    subscriptionWebhookMissingSignature: `Header „stripe-signature“ fehlt`,
    subscriptionWebhookSecretNotConfigured: `Webhook-Secret nicht konfiguriert`,
    tokenAlreadyUsed: `Token wurde bereits verwendet.`,
    tokenNotFound: `Token nicht gefunden.`,
    tooManyLoginAttempts: `Zu viele Anmeldeversuche. Bitte versuchen Sie es in {{retry_after}} Sekunden erneut. {{attempts_left_until_lock}} bis zur Kontosperre verbleibend.`,
    unexpectedError: `Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.`,
    userAccountCreationFailed: `Konto konnte nicht erstellt werden. Bitte versuchen Sie es erneut oder melden Sie sich an, falls Sie bereits ein Konto haben.`,
    userCannotDeleteSelf: `Superuser dürfen sich nicht selbst löschen.`,
    userDeletionFailed: `Kontolöschung konnte nicht geplant werden. Bitte später erneut versuchen.`,
    userEmailAlreadyVerified: `E-Mail bereits verifiziert.`,
    userEmailExists: `E-Mail konnte nicht aktualisiert werden. Bitte versuchen Sie eine andere.`,
    userEmailNotVerified: `E-Mail-Adresse nicht verifiziert.`,
    userEmailUpdateFailed: `E-Mail konnte nicht aktualisiert werden. Bitte versuchen Sie eine andere.`,
    userInactive: `Inaktiver Benutzer.`,
    userInsufficientPrivileges: `Benutzer verfügt nicht über ausreichende Berechtigungen.`,
    userNotAllowed: `Benutzer nicht berechtigt.`,
    userNotFound: `Benutzer nicht gefunden.`,
    userPrivacyNotAccepted: `Die Datenschutzerklärung muss akzeptiert werden, um ein Konto zu erstellen.`,
    userTermsNotAccepted: `Die Nutzungsbedingungen müssen akzeptiert werden, um ein Konto zu erstellen.`,
    userWithEmailNotFound: `Kein Benutzer mit dieser E-Mail im System gefunden.`,
    userWithIdNotFound: `Kein Benutzer mit dieser ID im System gefunden.`,
    userWithUsernameNotFound: `Kein Benutzer mit diesem Benutzernamen im System gefunden.`,
  },
  success: {
    accountScheduledForDeletion: `Ihr Konto wurde zur Löschung vorgemerkt.`,
    fileDeleted: `Datei erfolgreich gelöscht`,
    fileUploaded: `Datei erfolgreich in Azure Blob Storage hochgeladen`,
    fileUploadedToSession: `Datei erfolgreich im Sitzungsspeicher hochgeladen`,
    fileUploadUrlGenerated: `Upload-URL erfolgreich erzeugt`,
    loggedOut: `Erfolgreich abgemeldet`,
    passwordRecoveryEmailSent: `E-Mail zum Zurücksetzen des Passworts gesendet`,
    passwordUpdated: `Passwort erfolgreich aktualisiert`,
    sessionClosed: `Sitzung {{session_id}} geschlossen und zur Archivierung eingereiht`,
    userDeleted: `Benutzer erfolgreich gelöscht`,
    userVerified: `Benutzer erfolgreich verifiziert`,
    verificationEmailSent: `Verifizierungs-E-Mail erneut erfolgreich gesendet`,
  },
} as const;
